<template>
  <div :class="$style.container">
    <div
      v-m-b="20"
      :class="$style.date"
      v-text="displaySuccessDate"
    ></div>
    <div
      :class="$style.title"
      v-text="$t('crypto.payment.success.message.title')"
    ></div>
    <div
      v-m-b="20"
      :class="$style.description"
      v-text="$t('crypto.payment.success.message.description')"
    ></div>
    <div
      v-if="loading"
      :class="$style.action"
      v-text="$t('crypto.payment.success.message.action')"
    ></div>
  </div>
</template>

<script>
import { formatDateToCustomDate } from 'lib/utils/date';

export default {
  name: 'CryptoPaymentSuccess',
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    loading: Boolean,
  },
  computed: {
    displaySuccessDate() {
      const { transactions } = this.transaction;
      const transaction = [...transactions].pop();

      return `${formatDateToCustomDate(transaction.createdAt, 'HH:mm:ss')} UTC`;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    padding: 20px
    text-align: center
    color: var(--color-white)
    background-color: var(--color-green)
    border-radius: 5px

  .date
    +font-type('medium', 12, 18)
    text-align: left

  .title
    +font-type('medium', 12, 18)
    opacity: .5

  .description
    +font-type('regular', 18, 28)

  .action
    +font-type('medium', 14, 18)
    display: inline-block
    padding: 8px 20px
    background-color: rgba(255, 255, 255, 0.1)
    border-radius: 50px
</style>
